import {
  Form,
  Input,
  Button,
  Box,
  Center,
  Text,
  FormControl,
  FormErrorMessage,
  FormLabel
} from '@homebotapp/hb-react-component-catalog'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setHasPublicKey } from '../../../store/slices/auth'
import { useIntl, defineMessages } from 'react-intl'
import { HOME_SEARCH_PASSWORD_GATE } from '../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'

export const PasswordGate = () => {
  const PASSKEY = 'HBREBrokerage'
  const dispatch = useDispatch()
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const intl = useIntl()

  const checkPasskey = userPasskey => {
    if (userPasskey === PASSKEY) {
      setIsAuthenticated(true)
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(setHasPublicKey(true))
    }
  }, [dispatch, isAuthenticated])

  const MSG = defineMessages({
    submit: {
      id: 'passwordGate.submit',
      defaultMessage: 'Submit'
    },
    header: {
      id: 'passwordGate.header',
      defaultMessage: 'Welcome to HB Real Estate'
    },
    input: {
      id: 'passwordGate.input',
      defaultMessage: 'Enter Passkey'
    },
    error: {
      id: 'passwordGate.error',
      defaultMessage: 'Incorrect Passkey'
    }
  })

  return (
    <Box padding={4}>
      <Text as='h1' size='xl'>
        {intl.formatMessage(MSG.header)}
      </Text>
      <Center>
        <Box>
          <Form onSubmit={data => checkPasskey(data.passkey)}>
            {({ formState: { errors } }) => (
              <>
                <FormControl isInvalid={!!errors?.passkey} mb={4}>
                  <FormLabel>{intl.formatMessage(MSG.input)}</FormLabel>
                  <Input
                    type='password'
                    name='passkey'
                    rules={{
                      validate: value => value === PASSKEY || intl.formatMessage(MSG.error)
                    }}
                    tracking={{
                      guid: '8dQ8b9rZn2cFDzV1kZl3Xp',
                      ui_context: HOME_SEARCH_PASSWORD_GATE,
                      descriptor: 'Passkey Submission input for accessing the public home search'
                    }}
                  />
                  <FormErrorMessage>{errors?.passkey?.message?.toString()}</FormErrorMessage>
                </FormControl>
                <Button
                  type='submit'
                  tracking={{
                    guid: '8p79c6jYk3rDPqV2uF5pOx',
                    ui_context: HOME_SEARCH_PASSWORD_GATE,
                    descriptor: 'Passkey Submit Button Press for accessing the public home search'
                  }}
                >
                  {intl.formatMessage(MSG.submit)}
                </Button>
              </>
            )}
          </Form>
        </Box>
      </Center>
    </Box>
  )
}
